import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

class SettingsAppBar extends Component {
  state = {
    currentTab: 'account',
  }

  handleChange = (event, currentTab) => {
    this.setState({ currentTab });
  }

  getTabId() {
    if (this.props.location.pathname.includes('/settings/account')) {
      return 'account'
    } else if (this.props.location.pathname.includes('/settings/contributors')) {
      return 'contributors'
    } else {
      return 'account'
    }
  }

  render() {
    return(
      <Tabs value={this.getTabId()} onChange={this.handleChange} variant="scrollable" textColor='inherit' indicatorColor='secondary'>
        <Tab style={{minHeight:'72px'}} label="Account Settings" value='account' component={Link} to="/settings/account" />
        { this.props.isMultiUserMindfile ?
          <Tab style={{minHeight:'72px'}} label="Contributors" value='contributors' component={Link} to="/settings/contributors" />
          : ''
        }
      </Tabs>
    )
  }
}

const mapStateToProps = (state) => ({ isMultiUserMindfile: state.mindfile.group })

export default connect(mapStateToProps)(SettingsAppBar)
